// extracted by mini-css-extract-plugin
export default {"page":"ProfileAccountPage_page__DxcuU","copyButton":"ProfileAccountPage_copyButton__UySk0"};